export const SHOP_ALL_OPTIONS: { [key: string]: any } = {
  '/shop/new-arrivals': {
    description: 'Shop the latest in fine jewelry from hundreds of designers around the world.',
  },
  '/shop/necklaces': {
    description:
      'Shop our assortment of necklaces, from the everyday minimal to the statement-making evening piece.',
  },
  '/shop/bracelets': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/50f1d82f3d11517da9f35cb9a40d8590.jpg',
    description:
      'Invite some more friends to your arm party by shopping our selection of bracelets from hundreds of designers.',
  },
  '/shop/earrings': {
    description:
      'Shop all earrings – from studs, to drops, huggies, and crawlers – from the best jewelry designers in the world.',
  },
  '/shop/rings': {
    description:
      'Whether you are searching for "the one" or simply looking to add to your stack, our collection of rings is second to none.',
  },
  '/shop/bridal': {
    description:
      'Browse one-of-a-kind vintage rings and wedding bands and connect with a designer to buy.',
  },
  '/shop/semi-fine': {
    description: "Shop semi fine jewelry from the world's best designers. All in one place.",
  },
  '/shop/ships-tomorrow': {
    description:
      'These items are in stock and will be delivered just in time for the holidays.<br/><br/>Please select 2nd Day or Overnight at checkout* to arrive on time!<br/>2nd Day: Order by December 19<br/>Overnight: Order by December 20<br/>(*Additional charges will apply)',
  },
  '/shop/sustainable': {
    description: 'Check out these Pietra Shops that use sustainable materials in their designs.',
  },
};

export const GIFT_GUIDE_HELPER: { [key: string]: any } = {
  '/shop/all?tag=christmas_mom&title=Best%20Christmas%20Gift%20Ideas%20for%20Mom': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      "Explore our large variety of designs and you're bound to find amazing Christmas gift ideas for Mom.",
    titleTag: 'Best Christmas Gift Ideas For Mom',
    metaDescription:
      'Thinking of Christmas gift ideas for mom can be hard. At Pietra, we make it easier with our luxury jewelry that shows just how much you appreciate her.',
  },
  '/shop/all?tag=christmas_girlfriends&title=Best%20Christmas%20Gifts%20For%20Girlfriends': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      'Discover the perfect Christmas gifts for your girlfriend to make her stand out in the crowd.',
    titleTag: 'Guide To The Best Christmas Gifts For Girlfriends',
    metaDescription:
      "Make this holiday season truly special by finding the best Christmas gifts for your girlfriend. Nothing says 'I love you' like a beautiful piece of jewelry.",
  },
  '/shop/all?tag=unique_xmas_gifts&title=Unique%20Christmas%20Gifts%20for%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Unique Christmas gifts for her that are guaranteed to make the holidays special.',
    titleTag: 'Unique Christmas Gifts For Her - Luxury Jewelry',
    metaDescription:
      'Finding the Christmas Gift for your special someone can be hard. But, Pietra makes it easy with our large selection of unique Christmas gifts that are guaranteed to wow her.',
  },
  '/shop/all?tag=custom_for_her&title=Personalized%20Jewelry%20for%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      "Individualize an already meaningful gift with Pietra's personalized jewelry for her.",
    metaDescription:
      'Add a meaningful touch to any gift by ordering custom jewelry on Pietra. Our jewelry is the perfect way to show just how much you care.',
    titleTag: 'Personalized Jewelry Gifts For Her',
  },
  '/shop/all?tag=minimalist_gifts&title=Simple%20Jewelry%20Gifts%20for%20Minimalists': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Finding simple jewelry for the minimalist in your life is easy at Pietra.',
    titleTag: 'Designer Jewelry Gifts for Minimialists',
    metaDescription:
      'Looking for a gift for your minimalist friend? Look no further, at Pietra we have gorgeous yet simple designer jewelry perfect for minimalists.',
  },
  '/shop/all?tag=nature_lover_gifts&title=Nature%20Lovers%20Jewelry%20Gift%20Guide': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      'Express your love for the nature lover in your life with a beautiful piece of designer jewelry from Pietra.',
    titleTag: 'Gift Giving Guide For Nature Lovers - Jewelry Gifts',
    metaDescription:
      "Nature lovers are always thinking for the betterment of the environment around us, it's time to appreciate them with a stunning piece of fine jewelry from Pietra.",
  },
  '/shop/all?tag=romantic_gifts_her&title=Romantic%20Gifts%20for%20Her%20Birthday': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      'Find the most romantic birthday gifts for her with our selection of luxury jewelry.',
    titleTag: 'Romantic Birthday Gifts For Her',
    metaDescription:
      'Romance is in the air when you buy her a stunning piece of fine jewelry from Pietra. Start shopping our collection of romantic birthday gifts for her!',
  },
  '/shop/all?tag=50th_birthday&title=Meaningful%2050th%20Birthday%20Gifts': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Make her 50th birthday one to remember with a unique jewelry gift.',
    titleTag: 'Guide To The Best 50th Birthday Gift Ideas',
    metaDescription:
      "Celebrate her 50th birthday and make her feel special with a unique and beautiful jewelry gift from Pietra's wide selection. Start shopping now!",
  },
  '/shop/all?tag=animal_lover_gits&title=Animal%20Lovers%20Jewelry%20Gift%20Guide': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Find delicate, unique pieces that are perfect gifts for animal lovers.',
    titleTag: 'Thoughtful Gifts For Animal Lovers - Fine Jewelry',
    metaDescription:
      "Find unique and trendy pieces of jewelry that truly capitvates the spirit and values of an animal lover in Pietra's collection. Start shopping today.",
  },
  '/shop/all?tag=retirement_gifts&title=Retirement%20Gifts%20For%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    metaDescription:
      "Discover the perfect retirement gift to show your appreciation for her hardwork and dedication with designer jewelry from Pietra's collection.",
    description: 'The perfect high-end retirement gifts for her are a click away.',
    titleTag: 'Meaningful Retirement Gifts For Her',
  },
  '/shop/all?tag=big_sister_gifts&title=Customizable%20Gifts%20for%20Your%20Big%20Sister': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: "Celebrate your big sister's birthday with fine jewelry from Pietra's collection.",
    titleTag: 'Customizable Jewelry Gifts For Big Sisters',
    metaDescription:
      "Shop for customizable jewelry gifts that fit perfectly with your big sister's style. Pietra has the best in fine jewelry to make shopping for gifts easy.",
  },
  '/shop/all?tag=birthday_gifts_her&title=Birthday%20Jewelry%20for%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Fine jewelry serves as the perfect birthday gift for her.',
    titleTag: 'Birthday Gifts For Her - Birthday Jewelry',
    metaDescription:
      'Pietra has perfect birthday gifts for her so that you can show her just how much she means to you. Find beautiful luxury jewelry in our collection today!',
  },
  '/shop/all?tag=bridal_shower_gifts&title=Unique%20Bridal%20Shower%20Gifts': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Meaningful, unique bridal shower gifts to wish her a lifetime of happiness.',
    titleTag: 'Unique Bridal Shower Gifts - Jewelry Gifts For Bride',
    metaDescription:
      'Wish the beautiful bride a lifetime of happiness with her significant other with a unique bridal shower gift from Pietra.',
  },
  '/shop/all?tag=mother_of_groom&title=Gifts%20for%20the%20Mother%20of%20the%20Groom': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Find gorgeous jewelry gifts for the mother of the groom on Pietra.',
    titleTag: 'Best Gifts For The Mother Of The Groom',
    metaDescription:
      "Shop Pietra's collection to find the best mother of the groom gifts. With our classic, timeless pieces, you're bound to find the perfect piece.",
  },
  '/shop/all?tag=10yr_anniversary&title=10%20Year%20Anniversary%20Gifts': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    metaDescription:
      "Nothing says 'Happy 10 Year Anniversary!' like a gift from Pietra. With our fashion-forward pieces, you're bound to find the perfect piece for her.",
    titleTag: 'Memorable 10 Year Anniversary Gifts',
    description: 'Celebrate your 10 year anniversary with an eye-catching gift from Pietra.',
  },
  '/shop/all?tag=maid_of_honor&title=Maid%20of%20Honor%20Jewelry%20Gifts': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Say thank you to your maid of honor with a uniquely designed gift from Pietra.',
    titleTag: 'Maid Of Honor Jewelry Gifts ',
    metaDescription:
      "Show your appreciation for your maid of honor with a beautiful piece of jewelry from Pietra's collection. Find a unique piece to fit her preferences!",
  },
  '/shop/all?tag=wedding_shower&title=Custom%20Wedding%20Shower%20Gifts': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Discover the best custom wedding shower gifts for the bride.',
    titleTag: 'Custom Wedding Shower Gifts For The Bride',
    metaDescription:
      'Find a special, personalized wedding shower gift to wish the happy couple a lifetime of happiness filled with love! Start shopping our collection today.',
  },
  '/shop/all?tag=25th_anniversary&title=25th%20Anniversary%20Gifts%20for%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Make your 25th anniversary truly special with a unique jewelry gift for her.',
    titleTag: '25th Wedding Anniversary Gifts For Her ',
    metaDescription:
      '25th anniversaries are truly one of a kind, which is why the anniversary gift has to be too. Pietra makes it easy to find the perfect piece of jewelry.',
  },
  '/shop/all?tag=mother_of_bride&title=Gifts%20for%20the%20Mother%20of%20the%20Bride': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      'Find dazzling designer jewelry for the mother of the bride in our collection today.',
    titleTag: 'Luxury Jewelry Gifts For The Mother Of The Bride',
    metaDescription:
      'Find the perfect piece of jewelry on Pietra for the mother of the bride. Shop our collection for special pieces that are both thoughtful and elegant.',
  },
  '/shop/all?tag=engagement_gifts&title=Engagement%20Gifts%20For%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Gorgeous engagement gifts for her are a click away.',
    titleTag: 'Engagement Gifts For Her',
    metaDescription:
      "Say congratulations with a meaningful engagement gift for her. These perfect gifts are just a click away when you shop Pietra's Collection!",
  },
  '/shop/all?tag=anniversary_bands&title=Anniversary%20Bands%20For%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: "Find the perfect anniversary band for her by shopping Pietra's collection.",
    titleTag: 'Anniversary Bands For Her - Best Annniversary Gifts ',
    metaDescription:
      'Find a beautiful anniversary band to cherish your significant other and your endless love for each other. Start shopping our collection today!',
  },
  '/shop/all?tag=anniversary_gifts&title=Anniversary%20Gifts%20for%20Her': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description: 'Tell her you love her with a beautiful jewelry gift from Pietra.',
    titleTag: 'Jewelry Anniversary Gifts For Her',
    metaDescription:
      'At Pietra, our designer jewelry make for the perfect anniversary gifts for her. Find a special design for your special someone, on your special day!',
  },
  '/shop/all?tag=vday_gifts&title=Elegant%20Valentine%27s%20Day%20Gifts': {
    imageUrl:
      'https://static.pietrastudio.com/public/file_uploads/2b52fcb3327e176782b0baf5d6b0356d.png',
    description:
      "Make this Valentine's Day gift one to remember with a beautiful piece of jewelry from Pietra.",
    titleTag: "Valentine's Day Gifts - Jewelry For Her",
    metaDescription:
      "Explore Pietra's collection of Valentine's Day gifts to find the most elegant luxury jewelry on a trusted online marketplace. Start shopping today.",
  },
};

export const SHOP_ALL_CONFIG: { [key: string]: any } = Object.assign(
  {},
  GIFT_GUIDE_HELPER,
  SHOP_ALL_OPTIONS,
);
